module.exports = __webpack_public_path__ + "static/media/link.dd73ef33.svg";